export const tabData = [
  {
    name: "Basic Info",
  },
  {
    name: "Change Password",
  },
];
